import emptyFieldValidate from "@validators/shared/empty.validate";

export type TErrors = {
  question: string | undefined;
  answer: string | undefined;
  order: string | undefined;
};

const faqValidate = (FormValues: Record<string, any>) => {
  let errors: TErrors = {
    question: undefined,
    answer: undefined,
    order: undefined,
  };

  errors.question = emptyFieldValidate(FormValues.question, "Question");
  errors.answer = emptyFieldValidate(FormValues.answer, "Answer");
  errors.order = emptyFieldValidate(FormValues.order, "Order");

  return errors;
};

export default faqValidate;
